{
  "attrs.contentTitle": "Media title",
  "attrs.mediaId": "Asset ID",
  "attrs.mmn": "MMN",
  "attrs.lastUpdate": "Last update",
  "attrs.lastUpload": "Last upload",
  "attrs.mediaSource": "Media source",
  "attrs.origin": "Origin",
  "attrs.owner": "Owner",
  "attrs.keywords": "Keywords",
  "attrs.language": "Language",
  "attrs.type": "Media Type",
  "attrs.status": "Status",
  "attrs.incompleteReasons": "Invalidation reason",
  "attrs.hideInExplorer": "Hide the media in the media explorer",
  "attrs.devicePlatforms": "Supported device platforms",
  "attrs.targetGroup": "Target group",
  "attrs.relevantCountries": "Relevant countries",
  "attrs.excludedCountries": "Excluded countries",
  "attrs.legacyId": "Legacy ID",
  "attrs.excludedCountriesAsset": "Excluded countries (Asset settings)",
  "attrs.excludedCountriesProduct": "Excluded countries (Product)",
  "attrs.specialCategoryAsset": "Special category (Asset settings)",
  "attrs.specialCategoryProduct": "Special category (Product settings)",
  "attrs.collections": "Collections",
  "attrs.linkedProducts": "Linked Products",
  "attrs.name": "Name",
  "attrs.tenant": "Tenant",
  "attrs.tenantId": "Tenant ID",
  "attrs.logo": "Logo",
  "attrs.email": "Email",
  "attrs.firstName": "First name",
  "attrs.lastName": "Last name",
  "attrs.role": "Role",
  "attrs.specialCategory": "Special category",
  "attrs.actions": "Actions",
  "attrs.title": "Title",
  "attrs.url": "URL",
  "attrs.mediaFile": "Media file",
  "attrs.externalUrl": "External URL",
  "attrs.openBehavior": "Open behavior",
  "attrs.version": "Version",
  "attrs.platform": "Platform",
  "attrs.downloadUrl": "Download URL",
  "attrs.releaseDate": "Release date",
  "attrs.yes": "Yes",
  "attrs.no": "No",
  "attrs.push": "Push notification",
  "attrs.segment": "Segment",
  "enums.mediaItemStatus.ACTIVE": "Active",
  "enums.mediaItemStatus.INCOMPLETE": "Incomplete",
  "enums.mediaItemStatus.HIDDEN": "Hidden",
  "enums.supportedDevices.SMARTPHONE": "Smartphone",
  "enums.supportedDevices.TABLET": "Tablet",
  "enums.supportedDevices.DESKTOP": "Desktop",
  "enums.userRole.ADMIN": "Administrator",
  "enums.userRole.SUPER_ADMIN": "Super Admin",
  "enums.userRole.MANAGER": "Content Manager",
  "enums.userRole.USER": "App User",
  "enums.userStatus.ACTIVE": "active",
  "enums.userStatus.INACTIVE": "inactive",
  "enums.userStatus.DISABLED": "disabled",
  "enums.assetType.FILE": "File",
  "enums.assetType.LINK": "Link",
  "enums.openBehavior.IN_APP": "In-app web view",
  "enums.openBehavior.BROWSER": "External browser",
  "enums.origin.MANUAL": "Manual upload",
  "enums.origin.EXTERNAL": "External DAM",
  "enums.origin.EXTERNAL_DAM": "External DAM {{source}}",
  "btns.apply": "Apply",
  "btns.cancel": "Cancel",
  "btns.delete": "Delete",
  "btns.edit": "Edit",
  "btns.export": "Export",
  "btns.leave": "Leave",
  "btns.next": "Next",
  "btns.previous": "Previous",
  "btns.replace": "Replace",
  "btns.retry": "Retry",
  "btns.save": "Save",
  "btns.import": "Import",
  "btns.validate": "Validate",
  "btns.confirm": "Confirm",
  "btns.upload": "Upload",
  "btns.uploadNew": "Upload new",
  "btns.chooseFromGallery": "Choose from gallery",
  "btns.reload": "Reload",
  "btns.discard": "Discard",
  "core.toasts.deleted": "Deleted",
  "core.toasts.saved": "Saved",
  "core.noData": "There is nothing to show",
  "core.searchPlaceholder": "Search...",
  "core.selectPlaceholder": "Select...",
  "core.a11y.search": "Search",
  "core.a11y.clearSearch": "Clear search",
  "core.a11y.closeSearch": "Close search",
  "core.a11y.goBack": "Go back",
  "core.a11y.selectAll": "Select all",
  "core.a11y.selectRow": "Select row",
  "core.confirmDefault": "Are you sure?",
  "core.unsavedChanges.title": "Unsaved changes",
  "core.unsavedChanges.leave": "You have unsaved changes. Leave anyway?",
  "core.unsavedChanges.discard": "You have unsaved changes. Discard them?",
  "core.confirmDelete.irreversible": "This action cannot be undone.",
  "core.loading": "Loading...",
  "core.noResults": "No results",
  "core.noOptions": "No options found",
  "core.locked": "Locked",
  "core.showMore": "+{{count}} more",
  "core.showMore_one": "+{{count}} more",
  "core.showMore_other": "+{{count}} more",
  "core.showLess": "Show less",
  "core.nSelected": "{{count}} selected",
  "core.saving": "Saving…",
  "core.uploading": "Uploading…",
  "core.localizedTitlePlaceholder": "Enter title",
  "core.clearValue": "Clear value",
  "core.pagination.label": "Pagination",
  "core.pagination.results": "<bold>{{count}}</bold> results",
  "core.pagination.results_one": "<bold>{{count}}</bold> result",
  "core.pagination.results_other": "<bold>{{count}}</bold> results",
  "core.pagination.goToPage": "Go to page {{page}}",
  "core.pagination.firstPage": "First page",
  "core.pagination.previousPage": "Previous page",
  "core.pagination.nextPage": "Next page",
  "core.pagination.lastPage": "Last page",
  "errors.appError": "Something went wrong",
  "errors.timeout": "The server took too long to respond. Please try again.",
  "errors.network": "Network error. Please check your connection.",
  "errors.notFound": "The requested resource was not found.",
  "errors.serverError": "A server error occurred. Please try again later.",
  "errors.pageNotFound": "Page not found",
  "errors.pageNotFoundDescription": "The page you're looking for doesn't exist yet.",
  "errors.goToDashboard": "Go to Dashboard",
  "mediaAssets.title": "Media Assets",
  "mediaAssets.searchPlaceholder": "Search for a media title, Asset ID, keywords...",
  "mediaAssets.addNew": "Add a new asset",
  "mediaAssets.exportIncomplete": "Export incomplete",
  "mediaAssets.sections.visibility": "Visibility",
  "mediaAssets.sections.mediaFile": "Media file",
  "mediaAssets.sections.mediaDetails": "Media details",
  "mediaAssets.sections.relatedEntities": "Related entities",
  "mediaAssets.placeholders.searchProducts": "Search products…",
  "mediaAssets.actions.preview": "Preview content",
  "mediaAssets.actions.updatePicture": "Update picture",
  "mediaAssets.actions.reloadFile": "Reload media file",
  "mediaAssets.actions.replaceFile": "Replace media file",
  "mediaAssets.actions.uploadFile": "Upload media file",
  "mediaAssets.import.title": "Import asset list",
  "mediaAssets.import.noFileSelected": "No file selected",
  "mediaAssets.import.downloadExample": "Download import example",
  "mediaAssets.import.unsupportedFormat": "Unsupported file format. Expected: {{formats}}",
  "mediaAssets.import.validated": "{{count}} assets validated",
  "mediaAssets.import.validated_one": "{{count}} asset validated",
  "mediaAssets.import.validated_other": "{{count}} assets validated",
  "mediaAssets.import.canImport": "{{count}} assets can be imported",
  "mediaAssets.import.canImport_one": "{{count}} asset can be imported",
  "mediaAssets.import.canImport_other": "{{count}} assets can be imported",
  "mediaAssets.import.cannotImport": "{{count}} assets can not be imported because of wrong data format",
  "mediaAssets.import.cannotImport_one": "{{count}} asset can not be imported because of wrong data format",
  "mediaAssets.import.cannotImport_other": "{{count}} assets can not be imported because of wrong data format",
  "mediaAssets.import.warnings": "Warnings",
  "mediaAssets.import.warningLine": "Line #{{line}}: {{message}}",
  "mediaAssets.import.startedToast": "Import started",
  "mediaAssets.generalVisibility": "General visibility",
  "mediaAssets.columns.nameAssetId": "Name / Asset ID",
  "mediaAssets.columns.languageCountry": "Language / Country",
  "mediaAssets.columns.nameAssetIdType": "Name / Asset ID / Type",
  "mediaAssets.detail.title": "Asset details",
  "mediaAssets.create.title": "Add a new asset",
  "mediaAssets.toasts.created": "Asset created",
  "mediaAssets.toasts.createdUploadFailed": "Asset created, but the file upload failed. You can retry from the asset details.",
  "mediaAssets.toasts.savedUploadFailed": "Changes saved, but the file upload failed. You can retry from the asset details.",
  "mediaAssets.replaceFile.previewImage": "Preview image",
  "mediaAssets.replaceFile.createAutomatically": "Create automatically",
  "mediaAssets.replaceFile.keepPrevious": "Keep the previous one",
  "mediaAssets.replaceFile.uploadNew": "Upload new image",
  "mediaAssets.replaceFile.pendingHint": "Will be uploaded when you save",
  "mediaAssets.confirmReload.title": "Reload media file",
  "mediaAssets.confirmReload.description": "Are you sure you want to reload the media file from the source?",
  "mediaAssets.reloadStatus.processing": "Reloading the media file from the source…",
  "mediaAssets.reloadStatus.success": "Media file reloaded",
  "mediaAssets.reloadStatus.successWithoutChanges": "Media file reloaded — no changes detected",
  "mediaAssets.reloadStatus.failed": "Failed to reload the media file",
  "mediaAssets.confirmDelete.title": "Delete asset",
  "mediaAssets.confirmDiscardFile.title": "Discard uploaded file",
  "mediaAssets.confirmDiscardFile.description": "Saving this asset as a link permanently deletes its uploaded file. This action cannot be undone.",
  "mediaAssets.error.notFound": "Asset not found",
  "users.title.sso": "SSO Users",
  "users.title.system": "System Users",
  "users.title.leads": "Leads Users",
  "users.title.zeissId": "Zeiss-ID Users",
  "users.title.zeissIdShow": "Zeiss-ID User Details",
  "users.specialCategory.DORC": "DORC",
  "users.sync.syncUsers": "Sync Zeiss ID Users",
  "users.sync.syncUser": "Sync Zeiss ID User",
  "users.sync.retry": "refresh",
  "users.syncStatus.processing": "User sync with Zeiss ID is running.",
  "users.syncStatus.success": "User sync with Zeiss ID complete.",
  "users.syncStatus.failed": "User sync with Zeiss ID failed at: {{time}}.",
  "users.syncStatus.connectionError": "There is a connection issue.",
  "users.syncStatus.lastSync": "Last user sync with Zeiss ID started at: {{time}}",
  "users.syncStatus.currentStep.IMPORT_ZEISS_USERS": "Step 1 of 2: Import Zeiss users",
  "users.syncStatus.currentStep.SYNC_TO_AZURE": "Step 2 of 2: Sync changes to Azure",
  "users.detailSyncStatus.processing": "User sync with Zeiss ID is running.",
  "users.detailSyncStatus.success": "User synchronized with Zeiss ID.",
  "users.detailSyncStatus.failed": "User sync with Zeiss ID failed.",
  "users.detailSyncStatus.lastSync": "Last user profile changes in the Zeiss ID on {{time}}",
  "users.searchPlaceholder": "Search by name or email…",
  "users.columns.name": "Name",
  "users.columns.role": "Role",
  "users.columns.country": "Country",
  "users.columns.lastLogin": "Last login",
  "users.countryAssignments.manage": "Manage",
  "users.countryAssignments.moreCount": "+{{count}} more",
  "users.countryAssignments.moreCount_one": "+{{count}} more",
  "users.countryAssignments.moreCount_other": "+{{count}} more",
  "users.fields.interviewerGroups": "Interviewer groups",
  "users.adminPermissionsAlert": "Administrators have all permissions",
  "users.btns.activate": "Activate",
  "users.btns.disable": "Disable",
  "users.btns.resetPassword": "Reset password",
  "users.notFound": "User not found",
  "users.sections.profile": "Profile",
  "users.sections.assignments": "Assignments",
  "users.fields.country": "Country",
  "users.fields.lastLogin": "Last login",
  "users.confirmDelete.title": "Delete user",
  "users.confirmDisable.title": "Disable user",
  "users.confirmDisable.description": "The user will no longer be able to sign in.",
  "users.confirmActivate.title": "Activate user",
  "users.confirmActivate.description": "The user will be able to sign in again.",
  "users.confirmResetPassword.title": "Reset password",
  "users.confirmResetPassword.description": "The user will receive a password reset email.",
  "users.toasts.disabled": "User disabled",
  "users.toasts.activated": "User activated",
  "users.toasts.passwordReset": "Password reset email sent",
  "users.addNew": "Add a new user",
  "users.createTitle": "Add a new user",
  "users.toasts.created": "User created",
  "users.toasts.imported": "Users imported",
  "enums.incompleteReason.missed_relevant_country": "Relevant country or International version",
  "enums.incompleteReason.missed_collection": "Collection",
  "enums.incompleteReason.missed_target_group": "Target group",
  "enums.incompleteReason.missed_public_url": "Public download URL",
  "enums.incompleteReason.missed_top_level_collection": "Top level collection",
  "enums.incompleteReason.missed_content_title": "Content title",
  "enums.incompleteReason.warning_valid_from": "'valid from' date is in the future",
  "enums.incompleteReason.warning_valid_to": "'valid to' date is in the past",
  "enums.incompleteReason.missed_type_of_material": "Type of material",
  "enums.incompleteReason.latest_version_not_official_yet": "Latest version is not official yet. Last official version remains available for the app clients",
  "enums.incompleteReason.missed_official_version": "Official version is missing, asset is not available for the app clients",
  "enums.incompleteReason.missed_published_version": "Published version is missing",
  "enums.incompleteReason.update_in_progress": "Delay file update for a while",
  "enums.incompleteReason.unsupported_file_format": "Unsupported file format",
  "enums.incompleteReason.broken_download_url": "Invalid file URL",
  "enums.incompleteReason.file_not_match_type_of_material": "Material type does not match the file format, .zip file is expected",
  "enums.incompleteReason.file_too_large": "This file is too large to process (> 500 MB). Please upload an optimized version instead",
  "enums.incompleteReason.missed_language": "Media language is missing",
  "enums.incompleteReason.missed_product_and_collection_link": "No product assigned and no matching collection link",
  "mediaAssets.damAssignments.none": "Assignments: None",
  "login.backToLogin": "Back to Login",
  "login.signingIn": "Signing in…",
  "login.title": "SalesCase Management",
  "login.login": "Login",
  "login.loggingIn": "Logging in…",
  "login.subdomainLabel": "Please provide your subdomain",
  "login.separator": "and",
  "login.focusTitle": "FOCUS Management",
  "login.zeissIdButton": "Login with ZEISS ID",
  "login.or": "or",
  "login.email": "Email",
  "login.password": "Password",
  "login.errors.internalError": "An error occurred. Please try again.",
  "login.errors.unpermittedRole": "Your user does not have permission to use the backend.",
  "dashboard.title": "Dashboard",
  "dashboard.viewAll": "View all",
  "dashboard.kpi.totalSessions7d": "Total sessions (7d)",
  "dashboard.kpi.uniqueUsers7d": "Unique users (7d)",
  "dashboard.kpi.totalAssets": "Total assets",
  "dashboard.kpi.incompleteAssets": "Incomplete assets",
  "dashboard.panels.recentMedia": "New & updated media",
  "dashboard.panels.incompleteMedia": "Incomplete media",
  "dashboard.panels.sessionsPerDay": "Number of sessions (per day)",
  "dashboard.panels.sessionsPerWeek": "Number of sessions (per week)",
  "dashboard.panels.topUsed": "Top used media",
  "dashboard.panels.topShared": "Top shared media",
  "dashboard.empty.recent": "No recent media yet",
  "dashboard.empty.incomplete": "All media is valid",
  "dashboard.empty.sessions": "No session data for this period",
  "dashboard.empty.topUsed": "No usage data yet",
  "dashboard.empty.topShared": "No sharing data yet",
  "dashboard.sessions.header": "Sessions",
  "dashboard.sessions.uniqueUsers": "(unique users)",
  "dashboard.sessions.total": "Total",
  "dashboard.sessions.week": "Week",
  "dashboard.sessionsBreakdown.title": "Number of sessions",
  "dashboard.sessionsBreakdown.open": "Show breakdown for {{period}}",
  "dashboard.sessionsBreakdown.countries": "Countries",
  "dashboard.sessionsBreakdown.platforms": "Platforms",
  "dashboard.sessionsBreakdown.totals": "{{sessions}} sessions · {{users}} unique users",
  "dashboard.sessionsBreakdown.users": "{{count}} user",
  "dashboard.sessionsBreakdown.users_one": "{{count}} user",
  "dashboard.sessionsBreakdown.users_other": "{{count}} users",
  "dashboard.sessionsBreakdown.empty": "No sessions in this period",
  "enums.platform.iPad": "iPad",
  "enums.platform.iPhone": "iPhone",
  "enums.platform.Windows": "Windows",
  "enums.platform.Android": "Android",
  "enums.mobilePlatform.IOS": "iOS",
  "enums.mobilePlatform.ANDROID": "Android",
  "enums.mobilePlatform.WINDOWS": "Windows",
  "collections.searchPlaceholder": "Search collections and assets...",
  "collections.empty.subCollections": "No sub-collections here",
  "collections.sortMode.title": "Collection sorting",
  "collections.sortMode.automatic": "Automatic",
  "collections.sortMode.manual": "Manual",
  "collections.sortMode.automaticHint": "Sorted by the connected system, or alphabetically.",
  "collections.sortMode.manualHint": "Drag collections to change their order.",
  "collections.sortMode.confirmTitle": "Switch to automatic sorting?",
  "collections.sortMode.confirmDescription": "The manual order of the collections on this level will be lost. Collections will be sorted by the order from the connected system, or alphabetically if none is available.",
  "collections.sortMode.confirmAction": "Switch to automatic",
  "collections.addNew": "Add new collection",
  "collections.aria.dragHandle": "Drag to reorder {{name}}",
  "collections.aria.configureCollection": "Configure {{name}}",
  "collections.subCollectionCount": "{{count}} sub-collections",
  "collections.subCollectionCount_one": "{{count}} sub-collection",
  "collections.subCollectionCount_other": "{{count}} sub-collections",
  "collections.dialog.createTitle": "Add collection",
  "collections.dialog.editTitle": "Manage collection (ID: {{id}})",
  "collections.dialog.editProductTitle": "Edit product (ID: {{id}})",
  "collections.dialog.productMediaCollectionLink": "Product media collection link",
  "collections.dialog.deleteCollection": "Delete collection",
  "collections.dialog.cover": "Collection cover",
  "collections.dialog.addCover": "Add cover",
  "collections.dialog.updateCover": "Update cover",
  "collections.dialog.deleteCover": "Delete cover",
  "collections.dialog.coverFormats": ".png, .jpg, .jpeg",
  "collections.dialog.created": "Collection created",
  "collections.dialog.createdCoverFailed": "Collection created, but the cover image failed to upload. You can add it later from the collection.",
  "collections.dialog.updated": "Collection updated",
  "collections.dialog.updatedCoverFailed": "Collection updated, but the cover image failed to update. Try again from the collection.",
  "collections.dialog.deleted": "Collection deleted",
  "collections.dialog.source.title": "Source",
  "collections.dialog.linkType.title": "Collection link type",
  "collections.dialog.linkType.placeholder": "Choose collection link type",
  "collections.dialog.linkType.selectValue": "Select value",
  "collections.dialog.linkType.failedMapping": "Failed mapping: value not available",
  "collections.dialog.link.target": "Link target",
  "collections.dialog.link.targetMissing": "The linked target no longer exists. Select a new one.",
  "collections.dialog.link.linkTypeMissing": "The link has no type. Select a link type to repair it.",
  "collections.dialog.link.options.createSubfolders": "Create subfolders from source hierarchy",
  "collections.dialog.link.createSubfoldersHint": "Subfolders will be created according to the source structure.",
  "collections.dialog.link.turnOffHierarchy.title": "Turn off source hierarchy?",
  "collections.dialog.link.turnOffHierarchy.description": "On the next sync, all subfolders created from the source hierarchy will be removed and their assets will be moved directly into this folder. Settings of these subfolders, such as covers, will be lost.",
  "collections.dialog.link.turnOffHierarchy.confirm": "Turn off",
  "collections.dialog.link.turnOnHierarchy.title": "Turn on source hierarchy?",
  "collections.dialog.link.turnOnHierarchy.description": "On the next sync, subfolders will be created according to the source structure and assets will be distributed among them.",
  "collections.dialog.link.turnOnHierarchy.confirm": "Turn on",
  "collections.dialog.showInParent.label": "Show content in parent folder",
  "collections.dialog.showInParent.hint": "When enabled, this folder is not shown in the app. Its assets and subfolders are shown in the parent folder instead.",
  "collections.shownInParent": "Content shown in parent folder",
  "collections.notSynced": "Not synced to the app",
  "collections.linkBroken": "Link is broken",
  "collections.origin.manual": "Manually created",
  "collections.origin.generated": "Generated from source hierarchy",
  "collections.dialog.doNotSync.label": "Do not sync this folder to the app",
  "collections.dialog.doNotSync.hint": "The folder, its assets and subfolders are not shown in the app.",
  "collections.dialog.deleteConfirmTitle": "Delete collection?",
  "collections.dialog.deleteConfirmDescription": "This collection and all assets linked to it will be permanently deleted. This cannot be undone.",
  "staticPages.title": "Static Pages",
  "staticPages.countrySelector.default": "Default",
  "staticPages.countrySelector.lastUpdated": "Last updated: {{date}}",
  "staticPages.confirmRemoveCountry.title": "Remove country variant?",
  "staticPages.confirmRemoveCountry.description": "This will delete the {{country}} variant and all its content.",
  "staticPages.confirmRemoveCountry.confirm": "Remove",
  "staticPages.newVariant": "New — not yet saved",
  "staticPages.urlLabel": "URL",
  "staticPages.urlPlaceholder": "https://...",
  "staticPages.contentLabel": "Content",
  "staticPages.slugLabels.imprint": "Imprint",
  "staticPages.slugLabels.privacy": "Privacy Policy",
  "staticPages.countrySelector.removeCountry": "Remove {{country}}",
  "staticPages.addCountry": "Add a new country",
  "staticPages.openUrl": "Open URL in a new tab",
  "staticPages.typeOptions.imprint.URL": "Provide the url for the legal notice, the web page will be cached on the app client",
  "staticPages.typeOptions.imprint.CONTENT": "Provide the legal notice as formatted text, the content will be synced with the app client",
  "staticPages.typeOptions.privacy.URL": "Provide the url for the privacy policy, the web page will be cached on the app client",
  "staticPages.typeOptions.privacy.CONTENT": "Provide the privacy policy as formatted text, the page will be synced with the app client",
  "textTemplates.title": "Text Templates",
  "textTemplates.tabs.default": "Default",
  "textTemplates.subjectLabel": "Subject",
  "textTemplates.bodyLabel": "Email body",
  "textTemplates.signatureLabel": "Email signature",
  "textTemplates.errors.formInvalid": "The template could not be saved. Please check the fields and try again.",
  "companiesManagement.title": "Companies Management",
  "companiesManagement.addCompany": "Add company",
  "companiesManagement.backend": "Backend",
  "companiesManagement.edit": "Edit",
  "companiesManagement.empty": "No companies found",
  "companiesManagement.notFound": "Company not found",
  "companiesManagement.create.title": "New Company",
  "companiesManagement.detail.title": "Edit Company",
  "companiesManagement.sections.general": "Company settings",
  "companiesManagement.sections.appConfiguration": "App configuration",
  "companiesManagement.errors.backendFailed": "Failed to open the backend for this company",
  "companiesManagement.errors.imageUploadFailed": "Failed to upload image",
  "appVersions.title": "App versions",
  "appVersions.release": "Release version",
  "appVersions.empty": "No app versions released yet",
  "appVersions.current": "Current",
  "appVersions.dialog.title": "Release version",
  "leads.title": "Leads Management",
  "leads.sync.button": "Sync now",
  "leads.columns.id": "ID",
  "leads.columns.name": "Name",
  "leads.columns.city": "City",
  "leads.columns.country": "Country",
  "leads.columns.dates": "Dates",
  "leads.columns.reports": "Reports",
  "leads.columns.reportsPerDay": "Reports per day",
  "leads.columns.status": "Status",
  "leads.searchPlaceholder": "Search by name",
  "leads.empty.title": "No fairs found",
  "leads.detail.title": "Fair",
  "leads.detail.fairId": "Fair ID",
  "leads.detail.location": "Location",
  "leads.detail.dateRange": "Dates",
  "leads.detail.durationDays": "{{count}} days",
  "leads.detail.durationDays_one": "{{count}} day",
  "leads.detail.durationDays_other": "{{count}} days",
  "leads.detail.status": "Status",
  "leads.detail.reportsTitle": "Reports statistics",
  "leads.detail.notFound": "Fair not found",
  "leads.detail.kpi.totalReports": "Total reports",
  "leads.detail.kpi.activeFairUsers": "Active fair users",
  "leads.detail.kpi.activeDays": "Active days",
  "leads.detail.kpi.peakDay": "Peak day",
  "leads.detail.kpi.peakDayReports": "{{count}} reports",
  "leads.detail.kpi.peakDayReports_one": "{{count}} report",
  "leads.detail.kpi.peakDayReports_other": "{{count}} reports",
  "leads.detail.charts.reportsPerDay": "Reports per day",
  "leads.detail.charts.reports": "Reports",
  "leads.detail.slots.to08": "→ 08:00",
  "leads.detail.slots.from08to10": "08:00 – 10:00",
  "leads.detail.slots.from10to12": "10:00 – 12:00",
  "leads.detail.slots.from12to14": "12:00 – 14:00",
  "leads.detail.slots.from14to16": "14:00 – 16:00",
  "leads.detail.slots.from16to18": "16:00 – 18:00",
  "leads.detail.slots.from18": "18:00 →",
  "leads.detail.slots.total": "Total",
  "leads.fairUsers.title": "Assigned users",
  "leads.fairUsers.countLabel": "{{count}} users assigned",
  "leads.fairUsers.countLabel_one": "{{count}} user assigned",
  "leads.fairUsers.countLabel_other": "{{count}} users assigned",
  "leads.fairUsers.description": "Users assigned here can access this fair regardless of their relevant countries.",
  "leads.fairUsers.empty": "No users are assigned to this fair yet",
  "leads.fairUsers.searchPlaceholder": "Search users by name or email",
  "leads.fairUsers.selectPlaceholder": "Select users to assign",
  "leads.fairUsers.addButton": "Add",
  "leads.fairUsers.groups.sso": "SSO Users",
  "leads.fairUsers.groups.scBackend": "SC Backend Users",
  "leads.fairUsers.alreadyAssigned": "Assigned",
  "leads.fairUsers.noResults": "No users found",
  "leads.fairUsers.columns.assignedAt": "Assigned at",
  "leads.fairUsers.remove": "Remove assignment",
  "leads.fairUsers.toasts.assigned": "Users assigned.",
  "leads.fairUsers.toasts.removed": "Assignment removed.",
  "enums.userOrigin.SSO": "SSO",
  "enums.userOrigin.FOCUS": "SC Backend",
  "enums.userOrigin.ZEISS_ID": "Zeiss-ID",
  "enums.userOrigin.LEADS": "Leads Backend",
  "leads.syncStatus.processing": "Syncing fairs…",
  "leads.syncStatus.success": "Fairs synced",
  "leads.syncStatus.connectionError": "There is a connection issue.",
  "leads.syncStatus.currentStep.DATA_PREPARATION": "",
  "leads.syncStatus.currentStep.IMPORT_COLLECTIONS": "",
  "leads.syncStatus.currentStep.IMPORT_ASSETS": "",
  "leads.syncStatus.currentStep.CLEAN": "",
  "leads.syncStatus.currentStep.DOWNLOAD_FILES": "",
  "leads.syncStatus.currentStep.CALCULATE_USER_PERMISSIONS": "",
  "leads.syncStatus.currentStep.SYNC_TO_AZURE": "",
  "leads.syncStatus.currentStep.IMPORT_LEADS": "Import fair events from LEADS Backend",
  "syncStatus.button": "Start import",
  "syncStatus.processing": "Synchronizing…",
  "syncStatus.processingTime": "Data sync started at: {{time}}",
  "syncStatus.success": "Data synchronized",
  "syncStatus.failed": "Failed to sync at: {{time}}",
  "syncStatus.connectionError": "There is a connection issue.",
  "syncStatus.lastSync": "Last data sync at: {{time}}",
  "syncStatus.result": "Sync result: {{result}}",
  "syncStatus.resultUpdated": "{{value}} updated",
  "syncStatus.resultAdded": "{{value}} added",
  "syncStatus.resultDeleted": "{{value}} removed",
  "syncStatus.currentStep.DATA_PREPARATION": "Step 0 of 6: Data Preparation",
  "syncStatus.currentStep.IMPORT_COLLECTIONS": "Step 1 of 6: Import collections",
  "syncStatus.currentStep.IMPORT_ASSETS": "Step 2 of 6: Import assets",
  "syncStatus.currentStep.CLEAN": "Step 3 of 6: Clean deleted collections and assets",
  "syncStatus.currentStep.DOWNLOAD_FILES": "Step 4 of 6: Download new and updated assets",
  "syncStatus.currentStep.CALCULATE_USER_PERMISSIONS": "Step 5 of 6 Calculate user permissions",
  "syncStatus.currentStep.SYNC_TO_AZURE": "Step 6 of 6: Sync changes to Azure",
  "enums.fairStatus.upcoming": "In the future",
  "enums.fairStatus.active": "Active",
  "enums.fairStatus.sandbox": "Sandbox mode",
  "enums.fairStatus.finished": "Ended",
  "enums.fairStatus.archived": "Archived",
  "layout.sidebar.dashboard": "Dashboard",
  "layout.sidebar.reports": "Reports",
  "layout.sidebar.topShared": "Top Shared",
  "layout.sidebar.topUsed": "Top Used",
  "layout.sidebar.sessions": "Sessions",
  "layout.sidebar.updated": "Updated",
  "layout.sidebar.media": "Media management",
  "layout.sidebar.assets": "Assets",
  "layout.sidebar.collections": "Collections",
  "layout.sidebar.products": "Products",
  "layout.sidebar.leads": "Leads Management",
  "layout.sidebar.users": "User management",
  "layout.sidebar.usersSso": "SSO",
  "layout.sidebar.usersZeissId": "Zeiss ID",
  "layout.sidebar.usersSystem": "System",
  "layout.sidebar.usersLeads": "Leads",
  "layout.sidebar.settings": "Administration",
  "layout.sidebar.dashboardWidgets": "Dashboard Widgets",
  "layout.sidebar.staticPages": "Static Pages",
  "layout.sidebar.textTemplates": "Text Templates",
  "layout.sidebar.messenger": "Messenger",
  "layout.sidebar.companiesManagement": "Companies Management",
  "layout.sidebar.appVersions": "App versions",
  "layout.logout": "Log out",
  "layout.lightMode": "Light mode",
  "layout.darkMode": "Dark mode",
  "layout.appVersion": "App version: {{version}}",
  "reports.sessions.title": "Sessions",
  "reports.shared.title": "Top Shared Media",
  "reports.used.title": "Top Used Media",
  "reports.updated.title": "Updated Media",
  "reports.columns.nameAssetIdType": "Name / Asset ID / Type",
  "reports.columns.nameMMNType": "Name / MMN / Type",
  "reports.columns.targetGroup": "Target Group",
  "reports.columns.country": "Country",
  "reports.columns.shared": "Shared",
  "reports.columns.used": "Used",
  "reports.deletedAsset": "Deleted",
  "reports.columns.countries": "Relevant countries",
  "reports.columns.changedOn": "Changed on",
  "reports.columns.country2": "Country",
  "reports.columns.windows": "Windows",
  "reports.columns.iPad": "iPad",
  "reports.columns.iPhone": "iPhone",
  "reports.columns.androidTablet": "Android Tablet",
  "reports.columns.androidPhone": "Android Phone",
  "reports.columns.total": "Total",
  "reports.sessions.worldwide": "Worldwide",
  "reports.sessions.numbersHeader": "Number of sessions",
  "reports.sessions.online": "Online",
  "reports.sessions.offline": "Offline",
  "reports.datePicker.selectPeriod": "Select period",
  "reports.empty.noData": "No data for this period.",
  "reports.empty.noShares": "No shares in this period.",
  "reports.empty.noUsage": "No usage in this period.",
  "reports.breakdowns.countries": "Countries",
  "reports.breakdowns.targetGroups": "Target groups",
  "reports.errors.shareStatisticsFailed": "Failed to load share statistics.",
  "reports.errors.usageStatisticsFailed": "Failed to load usage statistics.",
  "products.title": "Products",
  "products.searchPlaceholder": "Search products and assets...",
  "products.empty.noSubProducts": "There are no sub-products",
  "products.aria.configureProduct": "Configure {{name}}",
  "products.dialog.editTitle": "Edit product",
  "products.dialog.updated": "Product updated",
  "products.dialog.excludedCountriesNote": "<b>NOTE:</b> Assets assigned to this product will be <b>marked as incomplete</b> and <b>hidden in the app</b> if they match defined country exclusions.",
  "products.dialog.syncNote": "<b>NOTE:</b> All changes will be applied after full sync",
  "products.dialog.excludedCountriesInherited": "Excluded countries (inherited)",
  "products.dialog.specialCategory": "Special category",
  "products.dialog.specialCategoryDorc": "DORC",
  "dashboardWidgets.title": "Dashboard Widgets",
  "dashboardWidgets.newWidget": "New widget",
  "dashboardWidgets.untitled": "(Untitled)",
  "dashboardWidgets.btns.addWidget": "Add a widget",
  "dashboardWidgets.btns.addFirstWidget": "Add the first widget",
  "dashboardWidgets.preview.label": "Preview mode",
  "dashboardWidgets.preview.tablet": "Tablet",
  "dashboardWidgets.preview.mobile": "Mobile",
  "dashboardWidgets.empty.noWidgets": "No widgets yet.",
  "dashboardWidgets.empty.noAssets": "No assets found",
  "dashboardWidgets.empty.noEvents": "No events found",
  "dashboardWidgets.fields.clickAction": "Click action",
  "dashboardWidgets.fields.pinToTop": "Pin to the top",
  "dashboardWidgets.fields.thumbnail": "Thumbnail",
  "dashboardWidgets.fields.collection": "Collection",
  "dashboardWidgets.fields.mediaAsset": "Media asset",
  "dashboardWidgets.fields.leadsEvent": "Leads+ event",
  "dashboardWidgets.fields.url": "URL",
  "dashboardWidgets.placeholders.url": "https://example.com",
  "dashboardWidgets.selectedCollection": "Selected: {{name}}",
  "dashboardWidgets.placeholders.searchCollections": "Search collections…",
  "dashboardWidgets.placeholders.loadingCollections": "Loading collections…",
  "dashboardWidgets.placeholders.searchEvents": "Search events…",
  "dashboardWidgets.placeholders.loadingEvents": "Loading events…",
  "dashboardWidgets.status.uploading": "Uploading…",
  "dashboardWidgets.toasts.added": "Widget added",
  "dashboardWidgets.toasts.updated": "Widget updated",
  "dashboardWidgets.toasts.deleted": "Widget deleted",
  "dashboardWidgets.toasts.imageUploaded": "Image uploaded",
  "dashboardWidgets.toasts.clickActionChanged": "Click action changed — pick a new target, or press Cancel to discard",
  "dashboardWidgets.errors.uploadImageFailed": "Failed to upload image",
  "dashboardWidgets.errors.formInvalid": "Please fill in all required fields before saving.",
  "dashboardWidgets.confirm.deleteTitle": "Delete widget?",
  "dashboardWidgets.confirm.deleteDescription": "\"{{title}}\" will be removed from the dashboard.",
  "dashboardWidgets.confirm.discardTitle": "Discard changes?",
  "dashboardWidgets.aria.deleteWidget": "Delete widget",
  "dashboardWidgets.aria.editWidget": "Edit widget",
  "dashboardWidgets.aria.dragWidget": "Drag to reorder",
  "dashboardWidgets.aria.clearSelection": "Clear selection",
  "dashboardWidgets.types.LEADS": "Create a New Lead",
  "dashboardWidgets.types.FAIR_LEADS": "Leads+ event",
  "dashboardWidgets.types.FAVORITES": "Favorites",
  "dashboardWidgets.types.PRODUCT": "Products",
  "dashboardWidgets.types.COLLECTION": "Media collection",
  "dashboardWidgets.types.MEDIA": "Media asset",
  "dashboardWidgets.types.EXTERNAL_LINK": "External link",
  "ui.richText.enterUrl": "Enter URL:",
  "ui.richText.invalidUrl": "That link can't be used. Check the address and try again.",
  "ui.richText.bold": "Bold",
  "ui.richText.italic": "Italic",
  "ui.richText.underline": "Underline",
  "ui.richText.strike": "Strikethrough",
  "ui.richText.heading1": "Heading 1",
  "ui.richText.heading2": "Heading 2",
  "ui.richText.heading3": "Heading 3",
  "ui.richText.bulletList": "Bullet list",
  "ui.richText.orderedList": "Ordered list",
  "ui.richText.blockquote": "Quote",
  "ui.richText.codeBlock": "Code block",
  "ui.richText.link": "Link",
  "ui.richText.image": "Insert image",
  "ui.richText.undo": "Undo",
  "ui.richText.redo": "Redo",
  "ui.richText.upload.dragDrop": "Drag and drop an image here",
  "ui.richText.upload.dropHere": "Drop the image to upload it",
  "ui.richText.upload.hint": "PNG or JPG · up to {{maxSize}}",
  "ui.richText.upload.chooseAnother": "Choose another file",
  "ui.richText.upload.dismiss": "Remove",
  "ui.richText.upload.unsupportedType": "That file type isn't supported. Use PNG or JPG.",
  "ui.richText.upload.tooLarge": "That image is over {{maxSize}}. Choose a smaller file.",
  "ui.richText.upload.failed": "Upload failed. Try again.",
  "ui.imagePicker.title": "Choose an image",
  "ui.imagePicker.deleteImage": "Delete image",
  "ui.imagePicker.replaceImage": "Replace image",
  "ui.imagePicker.imageDeleted": "Image deleted",
  "ui.imagePicker.imageReplaced": "Image replaced",
  "ui.imagePicker.deleteFailed": "Failed to delete image",
  "ui.imagePicker.replaceFailed": "Failed to replace image",
  "freeUser.registration.title": "Free account request",
  "freeUser.registration.description": "With the free account, you can record trade show reports for <b>10 days</b> and access them for an additional <b>10 days</b>.<br/><br/>After that, the account and all data will be automatically deleted",
  "freeUser.registration.submit": "Create account",
  "freeUser.registration.confirmationTitle": "Confirm your email",
  "freeUser.registration.confirmationDescription": "Email with verification link sent to your email.<br/><br/>Verify your email to start work with SalesCase app",
  "freeUser.registration.emailExistsTitle": "User with this email already exists.",
  "freeUser.registration.emailExistsDescription": "Please check your mail and login with received credentials",
  "freeUser.registration.genericError": "Something went wrong. Please try again.",
  "freeUser.verification.successTitle": "Your free SalesCase account has been activated.",
  "freeUser.verification.successDescription": "The login credentials have been sent via email and should arrive in your inbox within 5 minutes.<br/><br/>Enjoy using the SalesCase app!",
  "freeUser.verification.errorTitle": "Error",
  "freeUser.verification.errorDescription": "There is already an active test account for this email address.<br/><br/>If you forgot your login details, please use the password reset function in the app.",
  "freeUser.fields.email": "Email",
  "freeUser.fields.fullName": "Full name",
  "freeUser.fields.company": "Company name",
  "freeUser.fields.phone": "Contact phone number",
  "freeUser.privacyPolicy": "Privacy policy",
  "changePassword.title": "Change password",
  "changePassword.newPassword": "New password",
  "changePassword.repeatPassword": "Repeat new password",
  "changePassword.apply": "Apply changes",
  "changePassword.successTitle": "Success",
  "changePassword.successMessage": "Your password was changed successfully.",
  "changePassword.returnToLogin": "Please return to SalesCase App to log in again.",
  "changePassword.errorTitle": "Error",
  "changePassword.expiredMessage": "This password reset link has expired.",
  "changePassword.requestAgain": "Please request a new password reset in the app.",
  "notifications.title": "Messenger",
  "notifications.all": "All",
  "notifications.sendMessage": "Create message",
  "notifications.form.title": "Send message",
  "notifications.form.sections.message": "Message",
  "notifications.form.sections.audience": "Audience",
  "notifications.form.message": "Message",
  "notifications.form.allPlatforms": "All platforms",
  "notifications.form.allSegments": "All segments",
  "notifications.form.send": "Send",
  "notifications.form.specificUser": "Specific user",
  "notifications.form.userLoginPlaceholder": "Enter user login ID",
  "notifications.columns.message": "Message",
  "notifications.columns.push": "Push",
  "notifications.columns.targetGroups": "Target groups",
  "notifications.columns.countries": "Countries",
  "notifications.columns.sender": "Sender",
  "notifications.columns.sentAt": "Sent at",
  "notifications.detail.title": "Message details",
  "notifications.detail.notFound": "Message not found",
  "notifications.detail.sections.message": "Message",
  "notifications.detail.sections.audience": "Audience",
  "notifications.detail.sections.delivery": "Delivery",
  "notifications.toasts.sent": "Notification sent.",
  "notifications.confirm.title": "Send notification",
  "notifications.confirm.allTargetGroups": "No target groups selected — this notification will be sent to all target groups. Continue?",
  "notifications.confirm.allCountries": "No countries selected — this notification will be sent to all countries. Continue?"
}
